// 会话存储纯函数：与 window/localStorage 解耦，storage 由调用方注入，便于单测。
// 存储结构：{ accessToken, refreshToken, expiresIn, expiresAt, user }

export const SESSION_STORAGE_KEY = 'stellarcore_platform_session'

// 常量：access token 默认有效期（秒），refresh 响应未返回 expires_in 时按 14 天估算
export const ACCESS_TOKEN_TTL_SECONDS = 14 * 24 * 60 * 60

// 方法：读取会话；存储不可用或数据非法时返回 null
export function readSession(storage) {
  try {
    const value = storage.getItem(SESSION_STORAGE_KEY)
    return value ? JSON.parse(value) : null
  } catch (error) {
    return null
  }
}

// 方法：写入会话；session 为 null 时清除存储
export function writeSession(storage, session) {
  try {
    if (session) {
      storage.setItem(SESSION_STORAGE_KEY, JSON.stringify(session))
    } else {
      storage.removeItem(SESSION_STORAGE_KEY)
    }
    return session
  } catch (error) {
    return session
  }
}

// 方法：根据 expires_in（秒）计算过期时间戳；缺失或非法时按 14 天估算
export function buildExpiresAt(expiresInSeconds, now = Date.now()) {
  const seconds = Number(expiresInSeconds)
  if (Number.isFinite(seconds) && seconds > 0) {
    return now + seconds * 1000
  }
  return now + ACCESS_TOKEN_TTL_SECONDS * 1000
}

// 方法：会话是否未过期；未记录过期时间的历史会话视为有效，避免强制登出存量用户
export function isSessionValid(session, now = Date.now()) {
  return Boolean(
    session &&
    session.accessToken &&
    (!session.expiresAt || Number(session.expiresAt) > now)
  )
}
